import type { PhysicsStore } from "../core/store.js";
import type { StepDefinition } from "../data/schemas.js";
import { hasAllActions } from "../logic/condition-evaluator.js";

export interface GateResult {
  passed: boolean;
}

/** act 步骤门控：requiredActions 必须全部真实发生过（tech/108 §4.5 唯一硬门槛之一）。 */
export function checkActStep(store: PhysicsStore, step: StepDefinition): GateResult {
  return { passed: hasAllActions({ store }, step.id, step.requiredActions ?? []) };
}

/** record 步骤门控：该 Stage 的数据表行数达到 requiredTrials（默认 1）。 */
export function checkRecordStep(store: PhysicsStore, stageId: string, step: StepDefinition): GateResult {
  const required = step.requiredTrials ?? 1;
  return { passed: store.trialCount(stageId) >= required };
}

/** guess/design/conclude 从不阻断：提交即通过（对齐 000 文档 §七"允许孩子犯错"）。 */
export function checkChoiceStep(): GateResult {
  return { passed: true };
}
